export const PrimeDiscountDisplayType = {
  AMOUNT: 'amount',
  PERCENTAGE: 'percentage',
};
